module.exports = __webpack_public_path__ + "static/media/xgray.bdb6f53e.svg";